import React, { Component } from "react";
import PropTypes from "prop-types";
import Multiselect from "react-bootstrap-multiselect";

class CampaignsFilters extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    handleSaveFilters: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      filter_source_names: this.props.campaign.filter_source_names,
      filter_sender_ids: this.props.campaign.filter_sender_ids
    };
  }

  getMultiselectValues(ref) {
    let options = [].slice.call(ref.selectRef.options);
    let selected = options.filter(function(option) {
      return option.selected;
    });
    let selectedValues = selected.map(function(option) {
      return option.value;
    });
    return selectedValues;
  }

  handleChange() {
    let oldfilter_source_names = this.state.filter_source_names;
    let filter_source_names = this.getMultiselectValues(this.source_names);
    if (filter_source_names.includes("Any Source")) {
      if (
        filter_source_names.length > 1 &&
        oldfilter_source_names.includes("Any Source")
      ) {
        filter_source_names.splice(
          filter_source_names.indexOf("Any Source"),
          1
        );
      } else {
        filter_source_names = ["Any Source"];
      }
    }

    let filter_sender_ids = this.getMultiselectValues(this.sender_ids);
    let oldfilter_sender_ids = this.state.filter_sender_ids;
    if (filter_sender_ids.includes("Any Agent")) {
      if (
        filter_sender_ids.length > 1 &&
        oldfilter_sender_ids.includes("Any Agent")
      ) {
        filter_sender_ids.splice(filter_sender_ids.indexOf("Any Agent"), 1);
      } else {
        filter_sender_ids = ["Any Agent"];
      }
    }

    this.props.handleSaveFilters(this.props.campaign.id, {
      filter_sender_ids: filter_sender_ids,
      filter_source_names: filter_source_names
    });
    this.setState({
      filter_sender_ids: filter_sender_ids,
      filter_source_names: filter_source_names
    });
  }

  sourceOptions() {
    if (this.props.campaign.source_names) {
      let source_names = this.props.campaign.source_names;
      let filter_source_names = this.state.filter_source_names;
      source_names = ["Any Source"].concat(source_names);
      let options = source_names.map(source_name => {
        let selected =
          filter_source_names.indexOf(source_name) > -1 ? true : false;
        return { value: source_name, selected: selected };
      }, this);
      return options;
    }
  }

  agentOptions() {
    if (this.props.campaign.senders) {
      let senders = this.props.campaign.senders;
      let filter_sender_ids = this.state.filter_sender_ids;
      senders = [{ id: "Any Agent", name: "Any Agent" }].concat(senders);
      let options = senders.map(agent => {
        let selected =
          filter_sender_ids.indexOf(agent.id.toString()) > -1 ? true : false;
        return { value: agent.id, label: agent.name, selected: selected };
      }, this);
      return options;
    }
  }

  render() {
    return (
      <div className="panel panel-default campaign_filters">
        <div className="panel-heading">
          <h3 className="panel-title">
            Filter
            <span className="pull-right" style={{ fontWeight: "normal" }}>
              Automatically add a lead to this workflow with the following
              filter
            </span>
          </h3>
        </div>
        <div className="panel-body p-0">
          <div>
            <form className="filters_form">
              <div className={`row form-group`}>
                <div className="col-sm-5 m-l-20 campaign_filter_sources text-center">
                  <label className="filter_label">Lead Source</label>
                  <Multiselect
                    ref={(c) => { this.source_names = c; }}
                    data={this.sourceOptions()}
                    className="form-control filter_select"
                    onChange={this.handleChange.bind(this)}
                    buttonText={function(options, select) {
                      if (options.length > 1) {
                        return options.length + " selected";
                      } else if (options.length == 1) {
                        return options[0].label;
                      } else {
                        return "None selected";
                      }
                    }}
                    multiple
                  />
                </div>

                <div className="col-sm-1" style={{ marginTop: "6px" }}>
                  <strong> - And - </strong>
                </div>

                <div className="col-sm-5 campaign_filter_agents text-center">
                  <label className="filter_label">Assigned Agent</label>
                  <Multiselect
                    ref={(c) => { this.sender_ids = c; }}
                    data={this.agentOptions()}
                    className="form-control filter_select"
                    onChange={this.handleChange.bind(this)}
                    buttonText={function(options, select) {
                      if (options.length > 1) {
                        return options.length + " selected";
                      } else if (options.length == 1) {
                        return options[0].label;
                      } else {
                        return "None selected";
                      }
                    }}
                    multiple
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CampaignsFilters;
